import { Attendance } from '@/models/attendance';
import { Report } from '@/models/report.model';
import { Task } from '@/models/task.model';
import { UserInterface } from '@/models/user.model';
import { IWfh } from '@/models/wfh.model';
import axiosService from '@/services/axios/axios.service';

/**
 * Get activity statistics by admin
 * @param date - The date to get the statistics for
 * @param uid - The user id to get the statistics for
 * @returns 
 * return {
      user: plainToInstance(UserTransformer, user, { excludeExtraneousValues: true }),
      tasks: tasks || [],
      reports: reports || [],
      checkIns: checkIns || [],
      wfh: wfh || [],
    };
 */

interface IActivityStatistics {
    user: UserInterface;
    tasks?: Task[];
    reports?: Report[];
    checkIns?: Attendance[];
    wfh?: IWfh[];
    uniqueCheckInDays?: number;
    lateDays?: number;
    totalLeave?: number;
}

const getActivityStatistics = async ({
    date,
    uid,
}: {
    date: string;
    uid: string;
}): Promise<NonNullable<IActivityStatistics>> => {
    const response = await axiosService.get(
        `/statistical/get-statistical-by-admin?date=${date}&uid=${uid}`
    );
    return response.data;
};

export { getActivityStatistics };
